import { DELETE_CHAPTER_FILE, ADD_CHAPTER_FILE } from "redux/types";

export const deleteChapterFile = (chapterId, filename) => ({
    type: DELETE_CHAPTER_FILE,
    payload: { chapterId, filename },
});

export const addChapterFile = (chapterId, file) => ({
    type: ADD_CHAPTER_FILE,
    payload: { chapterId, file },
});